import { render, staticRenderFns } from "./AddToListAction.vue?vue&type=template&id=382f035e"
import script from "./AddToListAction.vue?vue&type=script&lang=js"
export * from "./AddToListAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports